var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnDrugAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.5,
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "white",
    stroke: "#0D5CDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5213 10.272H8.97725V12.848H7.02525V10.272H4.48125V8.64H7.02525V6.064H8.97725V8.64H11.5213V10.272Z",
    fill: "#0D5CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDrugAdd);
export default __webpack_public_path__ + "static/media/btn_drug_add.db2d37f895f5f5dae6bb43f3cd12defe.svg";
export { ForwardRef as ReactComponent };